<template>
  <div class="service-content">
    <ModuleTitleView :title="data?.title || ''"></ModuleTitleView>
    <div class="service-content-container" v-html="data.data"></div>
  </div>
</template>

<script setup>

import ModuleTitleView from "@/components/actricle/ModuleTitleView.vue"

const props = defineProps({
  jsonData: Object,
})

const data = reactive(props.jsonData)

</script>

<script>
export default {
  name: 'ServiceContentView'
}
</script>

<style scoped lang="less">

.service-content {
  width: 100%;
  margin-top: 50px;
  overflow: hidden;

  .service-content-container {
    padding: 0 120px;
    margin-top: 50px;

    :deep table {
      width: 100% !important;
      border-collapse: collapse !important;
      border-top: 2px solid var(--main-color) !important;
      border-bottom: 2px solid var(--main-color) !important;

      th, td {
        text-align: center !important;
        font-size: 16px !important;
        width: 100px !important;
        padding-top: 13px !important;
        padding-bottom: 13px !important;
        word-break: break-all !important;
      }

      th {
        font-weight: bold !important;
      }
    }

    :deep table > thead > tr > td > p {
      margin: 0 !important;
      padding: 0 !important;
    }

    :deep table > tbody > tr > td > p {
      margin: 0 !important;
      padding: 0 !important;
    }

    :deep tbody > tr {
      border-bottom: 1px solid #CACACA !important;
    }

    :deep tbody tr:last-child {
      border-bottom: 1px solid var(--main-color) !important;
    }

    :deep thead tr {
      border-bottom: 2px solid var(--main-color) !important;
    }

    :deep table thead tr td p strong {
      color: var(--main-color) !important;
      font-weight: bold;
      font-size: 16px !important;
      letter-spacing: 1px !important;
    }

    :deep table thead tr td p {
      color: var(--main-color) !important;
      font-size: 16px !important;
      font-weight: bold !important;
    }

    :deep .first-column {
      p {
        color: var(--font-color);
        font-size: 16px !important;
        letter-spacing: 1px !important;
      }
    }

    :deep tbody tr td {
      color: var(--font-color) !important;
      font-size: 16px !important;
      letter-spacing: 1px !important;
    }

    :deep table thead tr td p {
      color: var(--font-color) !important;
      font-size: 16px !important;
      letter-spacing: 1px !important;
    }
  }
}

</style>
